'use strict';
import * as $j_app$002eutils$002e$002dTauri$0024$002dOs$002dType$0024$0024anon$00241 from "./app.utils.-Tauri$-Os-Type$$anon$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $s_Lapp_utils_Tauri$OsType$__Windows__Lapp_utils_Tauri$OsType() {
  $m_Lapp_utils_Tauri$OsType$();
  return $t_Lapp_utils_Tauri$OsType$__Windows;
}
export { $s_Lapp_utils_Tauri$OsType$__Windows__Lapp_utils_Tauri$OsType as $s_Lapp_utils_Tauri$OsType$__Windows__Lapp_utils_Tauri$OsType };
function $s_Lapp_utils_Tauri$OsType$__Mac__Lapp_utils_Tauri$OsType() {
  $m_Lapp_utils_Tauri$OsType$();
  return $t_Lapp_utils_Tauri$OsType$__Mac;
}
export { $s_Lapp_utils_Tauri$OsType$__Mac__Lapp_utils_Tauri$OsType as $s_Lapp_utils_Tauri$OsType$__Mac__Lapp_utils_Tauri$OsType };
function $s_Lapp_utils_Tauri$OsType$__Linux__Lapp_utils_Tauri$OsType() {
  $m_Lapp_utils_Tauri$OsType$();
  return $t_Lapp_utils_Tauri$OsType$__Linux;
}
export { $s_Lapp_utils_Tauri$OsType$__Linux__Lapp_utils_Tauri$OsType as $s_Lapp_utils_Tauri$OsType$__Linux__Lapp_utils_Tauri$OsType };
function $s_Lapp_utils_Tauri$OsType$__Other__Lapp_utils_Tauri$OsType() {
  $m_Lapp_utils_Tauri$OsType$();
  return $t_Lapp_utils_Tauri$OsType$__Other;
}
export { $s_Lapp_utils_Tauri$OsType$__Other__Lapp_utils_Tauri$OsType as $s_Lapp_utils_Tauri$OsType$__Other__Lapp_utils_Tauri$OsType };
/** @constructor */
function $c_Lapp_utils_Tauri$OsType$() {
  $n_Lapp_utils_Tauri$OsType$ = this;
  $t_Lapp_utils_Tauri$OsType$__Windows = new $j_app$002eutils$002e$002dTauri$0024$002dOs$002dType$0024$0024anon$00241.$c_Lapp_utils_Tauri$OsType$$anon$1("Windows", 0);
  $t_Lapp_utils_Tauri$OsType$__Mac = new $j_app$002eutils$002e$002dTauri$0024$002dOs$002dType$0024$0024anon$00241.$c_Lapp_utils_Tauri$OsType$$anon$1("Mac", 1);
  $t_Lapp_utils_Tauri$OsType$__Linux = new $j_app$002eutils$002e$002dTauri$0024$002dOs$002dType$0024$0024anon$00241.$c_Lapp_utils_Tauri$OsType$$anon$1("Linux", 2);
  $t_Lapp_utils_Tauri$OsType$__Other = new $j_app$002eutils$002e$002dTauri$0024$002dOs$002dType$0024$0024anon$00241.$c_Lapp_utils_Tauri$OsType$$anon$1("Other", 3);
  $s_Lapp_utils_Tauri$OsType$__Windows__Lapp_utils_Tauri$OsType();
  $s_Lapp_utils_Tauri$OsType$__Mac__Lapp_utils_Tauri$OsType();
  $s_Lapp_utils_Tauri$OsType$__Linux__Lapp_utils_Tauri$OsType();
  $s_Lapp_utils_Tauri$OsType$__Other__Lapp_utils_Tauri$OsType();
}
export { $c_Lapp_utils_Tauri$OsType$ as $c_Lapp_utils_Tauri$OsType$ };
$c_Lapp_utils_Tauri$OsType$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_utils_Tauri$OsType$.prototype.constructor = $c_Lapp_utils_Tauri$OsType$;
/** @constructor */
function $h_Lapp_utils_Tauri$OsType$() {
}
export { $h_Lapp_utils_Tauri$OsType$ as $h_Lapp_utils_Tauri$OsType$ };
$h_Lapp_utils_Tauri$OsType$.prototype = $c_Lapp_utils_Tauri$OsType$.prototype;
$c_Lapp_utils_Tauri$OsType$.prototype.fromTauri__Ltypings_tauriAppsPluginOs_mod$OsType__Lapp_utils_Tauri$OsType = (function(tauri) {
  return ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(tauri, "windows") ? $s_Lapp_utils_Tauri$OsType$__Windows__Lapp_utils_Tauri$OsType() : ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(tauri, "macos") ? $s_Lapp_utils_Tauri$OsType$__Mac__Lapp_utils_Tauri$OsType() : ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(tauri, "linux") ? $s_Lapp_utils_Tauri$OsType$__Linux__Lapp_utils_Tauri$OsType() : $s_Lapp_utils_Tauri$OsType$__Other__Lapp_utils_Tauri$OsType())));
});
$c_Lapp_utils_Tauri$OsType$.prototype.ordinal__O__I = (function(x) {
  return x.Lapp_utils_Tauri$OsType$$anon$1__f__$ordinal$1;
});
var $d_Lapp_utils_Tauri$OsType$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_utils_Tauri$OsType$, "app.utils.Tauri$OsType$", ({
  Lapp_utils_Tauri$OsType$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_utils_Tauri$OsType$ as $d_Lapp_utils_Tauri$OsType$ };
var $n_Lapp_utils_Tauri$OsType$;
function $m_Lapp_utils_Tauri$OsType$() {
  if ((!$n_Lapp_utils_Tauri$OsType$)) {
    $n_Lapp_utils_Tauri$OsType$ = new $c_Lapp_utils_Tauri$OsType$();
  }
  return $n_Lapp_utils_Tauri$OsType$;
}
export { $m_Lapp_utils_Tauri$OsType$ as $m_Lapp_utils_Tauri$OsType$ };
var $t_Lapp_utils_Tauri$OsType$__Windows = null;
function $u_Lapp_utils_Tauri$OsType$__Windows(x) {
  $t_Lapp_utils_Tauri$OsType$__Windows = x;
}
export { $t_Lapp_utils_Tauri$OsType$__Windows as $t_Lapp_utils_Tauri$OsType$__Windows, $u_Lapp_utils_Tauri$OsType$__Windows as $u_Lapp_utils_Tauri$OsType$__Windows };
var $t_Lapp_utils_Tauri$OsType$__Mac = null;
function $u_Lapp_utils_Tauri$OsType$__Mac(x) {
  $t_Lapp_utils_Tauri$OsType$__Mac = x;
}
export { $t_Lapp_utils_Tauri$OsType$__Mac as $t_Lapp_utils_Tauri$OsType$__Mac, $u_Lapp_utils_Tauri$OsType$__Mac as $u_Lapp_utils_Tauri$OsType$__Mac };
var $t_Lapp_utils_Tauri$OsType$__Linux = null;
function $u_Lapp_utils_Tauri$OsType$__Linux(x) {
  $t_Lapp_utils_Tauri$OsType$__Linux = x;
}
export { $t_Lapp_utils_Tauri$OsType$__Linux as $t_Lapp_utils_Tauri$OsType$__Linux, $u_Lapp_utils_Tauri$OsType$__Linux as $u_Lapp_utils_Tauri$OsType$__Linux };
var $t_Lapp_utils_Tauri$OsType$__Other = null;
function $u_Lapp_utils_Tauri$OsType$__Other(x) {
  $t_Lapp_utils_Tauri$OsType$__Other = x;
}
export { $t_Lapp_utils_Tauri$OsType$__Other as $t_Lapp_utils_Tauri$OsType$__Other, $u_Lapp_utils_Tauri$OsType$__Other as $u_Lapp_utils_Tauri$OsType$__Other };
//# sourceMappingURL=app.utils.-Tauri$-Os-Type$.js.map
